import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c39b7ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "busStop-name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 즐겨찾기를 삭제하시면 설정하신 모든 정보가 삭제됩니다. 즐겨찾기를 삭제하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "favorite-busStop-row-container",
      role: "link",
      tabindex: "0",
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToBusStopInfoMap($props.favoriteBusStop.uid))),
      onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.goToBusStopInfoMap($props.favoriteBusStop.uid)), ["enter"])),
      "aria-label": `${$props.favoriteBusStop.name} 정류장 상세 정보로 이동`
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.favoriteBusStop.name), 1 /* TEXT */),
      _createVNode($setup["FavoriteStatusButton"], {
        class: "favorite-btn",
        shouldBeFilled: $setup.isFavorite($props.favoriteBusStop.uid),
        onOnClick: $setup.handleClickFavoriteStatusButton,
        "aria-label": `${$props.favoriteBusStop.name} 정류장 즐겨찾기 해제하기`,
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, null, 8 /* PROPS */, ["shouldBeFilled", "aria-label"])
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    ($setup.favoriteBusStopToRemove)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "즐겨찾기 삭제",
          okButtonTitle: "삭제하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: $setup.handleClickFavoriteBusStopRemoveAlertOk,
          onOnClickCancelButton: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateFavoriteBusStopToRemove('')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}